import "@/styles/partials/tools/novasole.css";

function init() {
  const novasoleIframe = document.querySelector(".novasole__iframe");

  if (!novasoleIframe) {
    return;
  }

  const novasoleOptions = document.querySelectorAll(
    "input[name='novasole_src']",
  );

  novasoleOptions.forEach((option) => {
    option.addEventListener("input", ({ target }) => {
      novasoleIframe.classList.add("novasole__iframe--active");
      novasoleIframe.addEventListener("load", () => {
        document.querySelector(".novasole__form")?.remove();
      });
      novasoleIframe.setAttribute("src", (target as HTMLInputElement).value);
    });
  });
}

init();
